/*
https://medium.com/coderbyte/lets-make-a-five-star-rating-page-using-angular-f9509fdd682d
*/

import { Component, ElementRef, OnInit, Input, SimpleChanges, OnChanges, Output, EventEmitter, } from "@angular/core";
import { Location, ViewportScroller } from "@angular/common";
import { NgxSpinnerService } from "ngx-spinner";
import { AlertService } from "@app/modules/alert";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "environments/environment";

import { GlobalConstants } from "@app/utils/global-constants";

import { WorkRequest } from "@app/models/work-request";
import { WorkRequestService } from "@app/services/work-request.service";
import { FormBuilder, UntypedFormBuilder, Validators } from "@angular/forms";
import { FeedbackService } from "@app/services/feedback.service";
import { AzureUser } from "@app/models/azure-user";
import { getCurrentUserFromStorage } from "@app/utils/storage-utils";
import { IWorkRequestFeedback } from "@app/models/feedback";
import { UserType } from "@app/models/common";
import { GlobalService } from "@app/services/global.services";

@Component({
    selector: "app-feedback",
    templateUrl: "./feedback.component.html",
    styleUrls: ["./feedback.component.scss"],
})
export class FeedbackComponent implements OnInit, OnChanges {

    @Input() inputWorkRequest: WorkRequest; 
    @Output() closingComponent: EventEmitter<boolean> = new EventEmitter();

    workRequestId: number;
    workRequest: WorkRequest;
    workRequestForm = this.formBuilder.group({});
    feedbackForm = this.formBuilder.group({});
    currentUser: AzureUser;
    userType : UserType;
    screenMode : string = GlobalConstants.FEEDBACK_FORM_MODE_ENTRY;

    btnSubmitHide = false;
    btnDisableButtons  = false;

    msg = {
        entryNotFound: "The work request was not found",
        feedbackAlreadySubmitted : "Feedback for this work order has already been submitted.",
        requestNotClosed : "Error: The work order has not been closed yet.",
        invalidRequestType : "Error: feedback is only solicited for work orders.",
        invalidUser : "Error: Only the requestor can submit feedback."
    }
    errorMessageOptions = {
        autoClose: false,
        keepAfterRouteChange: true,
    };
    warnMessageOptions = {
        autoClose: true,
        keepAfterRouteChange: true,
    };
    saveMesageOptions = {
        autoClose: true,
        keepAfterRouteChange: true,
    };
 
    constructor(
        public alertService: AlertService,
        private globalService: GlobalService,
        private workRequestService: WorkRequestService,
        private feedbackService: FeedbackService,
        private formBuilder: UntypedFormBuilder,
        private spinner: NgxSpinnerService,
        private router: Router,
        private route: ActivatedRoute,
        private el: ElementRef,
        private location: Location,
        private viewportScroller: ViewportScroller,
    ) {
        this.buildForm();
    }

    ngOnInit(): void {
        this.currentUser = getCurrentUserFromStorage();
        this.userType = this.globalService.checkGroupAccess();
        //if the ID is passed use it to get workrequest, 
        //otherwise the workrequest will be passed via input
        this.route.paramMap.subscribe((params) => {
            const id = params.get("id");
            if (id) {                
                this.workRequestId = +params.get("id")!;
                this.getWorkRequest();
  
            }
        });
        this.route.data.subscribe(data => {
            this.screenMode = data["mode"];
        })
       
        
    }

    /**
     * This triggers when the component input changes (ie. from parent)
     * @param changes 
     */
    ngOnChanges(changes: SimpleChanges) {
        //console.log('Variable changed:', changes['inputWorkRequest'].currentValue);
        if (changes['inputWorkRequest'].currentValue) {
            this.screenMode = GlobalConstants.FEEDBACK_FORM_MODE_VIEW;
            this.btnSubmitHide = true;
            this.feedbackForm.disable();
            this.currentUser = getCurrentUserFromStorage();
            this.workRequest = this.inputWorkRequest;
            this.setDataInForm();

        }
    }


    buildForm() {
        this.workRequestForm = this.formBuilder.group(
            {
                subject : ["", []],
                businessRequirements : ["", []],
                resolution : ["", []],               
            }
        );
        this.feedbackForm = this.formBuilder.group(
            {
                workRequestId: [null],
                rating: [null, [Validators.required]],  
                easeOfSupport: ["", [Validators.required]],  
                supportComments:["", []],  
                opportunities : ["", []],  
                additionalComments : ["", []],            
            }
        );
    }

    getWorkRequest() {
        this.spinner.show();

        //Use USER by default which is used for when a user enters feedback.
        //If an Admin uses a direct link, he needs the admin api to gain access.
        let mode =  GlobalConstants.REQUEST_FORM_MODE_USER;
        if (this.userType.isAdmin) {
            mode = GlobalConstants.REQUEST_FORM_MODE_ADMIN
        }
        this.workRequestService
            .getWorkRequest(this.workRequestId, mode)
            .subscribe({
                next: (response: WorkRequest) => {

                    if (response === null) {
                        this.alertService.error(
                            this.msg.entryNotFound,
                            this.errorMessageOptions

                        );
                        this.spinner.hide();
                        this.router.navigate(["/home"]);
                    }

                    this.workRequest = response;
                    this.setDataInForm();
                    this.spinner.hide();
                }
                , error: (err: any) => {
                    this.alertService.error(
                        this.msg.entryNotFound,
                        this.errorMessageOptions

                    );
                    this.spinner.hide();
                }
            });
    }
    

    setDataInForm() {

        this.workRequestForm.get("subject")?.setValue(this.workRequest.subject);
        this.workRequestForm.get("businessRequirements")?.setValue(this.workRequest.businessRequirements);
        this.workRequestForm.get("resolution")?.setValue(this.workRequest.resolution);

        if (this.workRequest.feedback && this.workRequest.feedback?.rating > 0) {
            this.feedbackForm.get("rating")?.setValue(this.workRequest.feedback?.rating);
        }
        this.feedbackForm.get("opportunities")?.setValue(this.workRequest.feedback?.opportunities);
        this.feedbackForm.get("additionalComments")?.setValue(this.workRequest.feedback?.additionalComments);
        this.feedbackForm.get("easeOfSupport")?.setValue(this.workRequest.feedback?.easeOfSupport);
        this.feedbackForm.get("supportComments")?.setValue(this.workRequest.feedback?.supportComments);
        this.workRequestForm.disable();

        if (this.screenMode ===  GlobalConstants.FEEDBACK_FORM_MODE_VIEW) {
            this.feedbackForm.disable();
            this.btnSubmitHide = true;
        } else {
            let errmsg = "";
            if (this.workRequest.status !== GlobalConstants.STATUS_CLOSED) {
                errmsg = this.msg.requestNotClosed;
            }
            if (!GlobalConstants.FEEDBACK_REQUESTS.find(i => i === this.workRequest.requestType )) {
                errmsg = this.msg.invalidRequestType;
            }
            //this shouldn't happen as the user can only retrieve their own work requests. 
            if (this.workRequest.requestorAzureId !== this.currentUser.id) {
                errmsg = this.msg.invalidUser;
            }

            if (this.workRequest.feedback !== null) {
                errmsg = this.msg.feedbackAlreadySubmitted;
            }



            if (errmsg !== "") {
                this.feedbackForm.disable();
                this.btnSubmitHide = true;

                this.alertService.warn(
                    errmsg,
                    this.warnMessageOptions

                );

            }
        }
        this.focusError("feedback-form-header");
    }

    submitForm() {

        if (this.feedbackForm.valid) {
            this.spinner.show();
            this.btnSubmitHide = true;
            const fb = this.feedbackForm.value;
            fb.workRequestId = this.workRequestId;
           this.feedbackService.postfeedback(fb).subscribe({
            next: () => {
                this.router.navigate(["/home"]);
                this.alertService.info("Your feedback has been submitted.", this.saveMesageOptions);
                this.spinner.hide();
            },
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            error: (err: any) => {
                const msg = err.status === 400 ? "Invalid submission attempt." : err.message;
                this.handleError(msg);
                this.spinner.hide();
            },
        });
    
        } else {
            this.focusError("feedback-form");
        }

    }

    focusError(docLocation: string) {
        document.getElementById(docLocation)?.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });
    }


    goBack() {

        if (this.inputWorkRequest) {
            this.closingComponent.emit(true);
        } else {
            this.location.back();
        }
    }


    handleError(msg: string) {
        this.spinner.hide();
        this.viewportScroller.scrollToPosition([0, 0]);
        this.alertService.error(msg);
        this.btnSubmitHide = false;

    }

 }
